export default __webpack_public_path__ + "static/media/JO.6d45f2e5.svg";